import React, { Fragment } from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import PencilIcon from 'react-icons/lib/fa/pencil'
import CloseIcon from 'react-icons/lib/fa/close'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const ContextMenu = ({
  classes,
  id,
  openAgeGroupDialog,
  groupName,
  retirePupil,
  onDelete,
  onEdit,
  canEdit
}) => (
  <DropMenu
    popoverClassName={classes.contextMenuHolder}
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <MenuItem onClick={() => closePopover() && onEdit()}>
          <IconHolder>
            <PencilIcon />
          </IconHolder>
          Edit group
        </MenuItem>
        {canEdit && (
          <Fragment>
            <Separator />
            <MenuItem
              onClick={() => {
                closePopover()
                openConfirmationDialog({
                  bodyText: `Are you sure you want to delete ${groupName} ?`,
                  confirmText: 'Delete group',
                  action: () => onDelete()
                })
              }}
              className={classes.retirePupil}>
              <IconHolder>
                <CloseIcon />
              </IconHolder>
              Delete group
            </MenuItem>
          </Fragment>
        )}
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
